import { createContext } from "react";

//Creo el contexto
const tareaContext = createContext()

export default tareaContext